import React from 'react';
import { css } from '@emotion/css';
import { css as globalCss, Global } from '@emotion/react';
import { withBasicStyles, primaryBlue, lightBlue, darkGray, lightGray, borderGray } from '@/styles/common';

export const useStyles = withBasicStyles(() => ({
  // 静态样式
  wrapper: css`
    display: flex;
    flex-direction: column;
    // max-height: 812px;
    min-height: 300px;
    max-width: 800px;
    width: 100%;
    height: 100%;
    min-width: 375px;
    // background-color: #fff;
    // border: 1px solid rgba(80,96,122,.15);
    border-radius: 12px;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  `,

  navbar: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    border-bottom: 1px solid ${borderGray};
    // background-color: #fff;
  `,

  userAvatar: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
  `,

  avatar: css`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
    border: 1px solid ${borderGray};
  `,

  title: css`
    font-weight: 600;
    font-size: 16px;
    color: ${darkGray};
  `,

  subtitle: css`
    font-size: 12px;
    color: ${lightGray};
    margin-top: 2px;
  `,

  messageContainer: css`
    flex: 1;
    overflow-y: auto;
    padding: 16px 0;
    // background-color: #fff;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 0;
    position: relative;

    &::-webkit-scrollbar {
      display: none;
    }

    .ant-attachment-list-card-type-preview {
      width: 52px;
      height: 52px;
    }
    .ant-attachment .ant-attachment-list-upload-btn {
      width: 52px;
      height: 52px;
      font-size: 24px;
    }
    .ant-attachment-list-card-type-overview {
      padding: 9px;
      line-height: 1;
    }
    .ant-attachment-list-card-type-overview .ant-attachment-list-card-icon {
      display: flex;
      padding-top: 0px;
    }
    .ant-attachment-list-card .ant-attachment-list-card-name {
      margin-bottom: 4px;
    }
    .ant-attachment-list-card-motion-leave-active {
      display: none;
    }
    .ant-progress-inner {
      width: 44px!important;
      height: 44px!important;
    }
    .ant-progress-text {
      font-size: 12px;
    }
  `,

  messageList: css`
    padding: 0 16px;
    /* 隐藏 webkit 浏览器的滚动条 */
    &::-webkit-scrollbar {
      display: none;
    }
    
    /* 隐藏 Firefox 的滚动条 */
    scrollbar-width: none;
    
    /* 隐藏 IE 的滚动条 */
    -ms-overflow-style: none;
  `,

  emptyWrapper: css`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: '#222';
    user-select: none;
  `,

  emptyImg: css`
    width: 60px;
    height: 60px;
    border-radius: 8px;
    margin-bottom: 16px;
  `,

  message: css`
    max-width: 70%;
    padding: 10px 14px;
    border-radius: 20px;
    background-color: ${lightBlue};
    color: ${darkGray};
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  `,

  messageRight: css`
    align-self: flex-end;
    background-color: ${primaryBlue};
    color: white;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  `,

  quickReplies: css`
    display: flex;
    gap: 8px;
    padding: 10px 16px;
    border-top: 1px solid ${borderGray};
    background-color: #fff;
    overflow-x: auto;
  `,

  replyItem: css`
    padding: 6px 12px;
    font-size: 13px;
    border: 1px solid ${primaryBlue};
    border-radius: 20px;
    background-color: #fff;
    color: ${primaryBlue};
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    transition: all 0.2s ease;
  
    &:hover {
      background-color: ${primaryBlue};
      color: #fff;
    }
  `,

  highlight: css`
    background-color: ${primaryBlue};
    color: white;
    border-color: ${primaryBlue};
  `,

  stepLine: css`
    border-top: 1px dashed #C3CFFB;
    width: 100%;
    margin: 16px 0;
  `,

  inputBar: css`
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-top: 1px solid ${borderGray};
    background-color: #fff;
  `,

  input: css`
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${borderGray};
    border-radius: 20px;
    font-size: 14px;
    outline: none;
  
    &:focus {
      border-color: ${primaryBlue};
      box-shadow: 0 0 3px ${primaryBlue};
    }
  `,
  actionDetailContent: css`
    border-left: 1px solid #C1C3CD;
    padding-right: 16px;
    padding-left: 11px;
    margin-bottom: 12px;
    margin-left: 25px;
    font-weight: 400;
    font-size: 14px;
    color: #767985;
    line-height: 20px;
    display: inline-block;
    white-space: 'pre-line';
  `,
  actionHeaderWrapper: css`
    margin-bottom: 12px;
  `,
  actionHeaderIcon: css`
    height: 14px;
    margin-right: 5px;
  `,
  actionHeaderDetail: css`
    background: #F3F5FA;
    border-radius: 8px;
    overflow: hidden;
  `,
  actionDetailTitle: css`
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    background: #EDEFF5;
    height: 32px;
    margin-bottom: 12px;
    cursor: pointer;
  `,
  executeHeaderIcon: css`
    height: 12px;
    padding-right: 10px !important;
  `,
  actionTitle: css`
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    background: #EDEFF5;
    height: 32px;
    margin-bottom: 12px;
    cursor: pointer;
    border-radius: 8px;
    min-width: 200px;
  `,
  actionHeaderDetailItem: css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    padding: 0 16px;
    margin-bottom: 12px;
    color: #949494;
  `,
  actionHeaderCost: css`
    margin-left: auto;
    color: #888;
    font-size: 12px;
    min-width: 32px;
    text-align: right;
  `,
  executeHiddenWrapper: css`
    background: #FFFFFF;
    border-radius: 8px;
    margin: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    box-sizing: border-box;
    padding: 0px 16px;
    font-size: 14px;
    margin-bottom: 12px;
    color: #3961F2;
  `,
  executeTitle: css`
    display: flex;
    align-items: center;
    padding: 6px 16px;
    height: 40px;
    box-sizing: border-box;
    cursor: pointer;
  `,
  executeContent: css`
    border-top: 1px solid rgba(0,0,0,0.08);
    padding-top: 10px;
  `,
  executeWrapper: css`
    background: #FFFFFF;
    border-radius: 8px;
    padding-bottom: 1px;
    margin: 12px;
  `,
}));

export const GlobalStyle: React.FC = () => (
  <Global
    styles={globalCss`
      .ant-bubble-footer {
        display: flex;
        align-items: center;
        min-width: 0,
        max-width: 600,
        /* 你想覆盖的其他样式 */
      }

      .ant-sender-content {
        textarea {
          word-break: break-all;
        }
      }

      .ant-avatar {
        background-color: transparent;
      }

      .ant-sender-actions-list {
        margin-left: -40px;
      }

      .ant-sender {
        box-shadow: none !important;
      }

      .ant-prompts-item {
        padding-block: 8px !important;
      }

      /* 用户消息气泡背景色 */
      .ant-bubble .user-content {
        background-color: #D8E0FD;
      }

      /* 助手消息气泡背景色 */
      .ant-bubble .assistant-content {
        background-color: transparent;
        min-height: 0;
        padding: 0;
      }
    `}
  />
);
